export const about5aLink = Object.freeze({
  'pt-BR': '/v2/home',
  'es-MX': '/v2/home',
});

export const tenantLink = Object.freeze({
  'pt-BR': '',
  'es-MX': '',
});

export const ownerLink = Object.freeze({
  'pt-BR': '',
  'es-MX': '',
});

export const affiliateAppLink = Object.freeze({
  'pt-BR': '/indica-ai',
  'es-MX': '/indica-ai',
});

export const agentAppLink = Object.freeze({
  'pt-BR': '/v2/home',
  'es-MX': '/v2/home',
});

export const agentSpaceLink = Object.freeze({
  'pt-BR': {
    AGENT_SPACE_URL: '/v2/home',
  },
  'es-MX': {
    AGENT_SPACE_URL: '/v2/home',
  },
});

export const getOwnerPropertiesLink = (locale) => {
  if (ownerLink[locale]) return `${ownerLink[locale]}/meus-imoveis`;

  return '/chats/corretor-proprietario';
};
